import * as React from 'react';
import AccountsByFundGroupCore from '../FundGroupOrientation/AccountsByFundGroupCore';
import { useAppSelector, useAppDispatch } from '../../hooks/index';
import { setIsDirty, isAdmin } from '../../redux/MiscSlice';
import { UserRoleEnum } from '../../redux/UserSlice';

const AccountsByComponentUnitsA = (props: any) => {
    const isAdminUser: boolean = useAppSelector(isAdmin);

    return (
        <React.Fragment>
            <AccountsByFundGroupCore userRole={isAdminUser ? UserRoleEnum.Admin : UserRoleEnum.EntityUser}
                fundGroup="Component Units"
                noData="workState_noComponentUnitsFunds"
                done="workState_componentUnitsFundsComplete"
                reviewed="reviewState_componentUnitsFundsReviewed"
            />
        </React.Fragment>
    );
}

export default AccountsByComponentUnitsA;